export default "__VITE_ASSET__CKudGWwe__$_?height=200&width=300__"